module.exports = __webpack_public_path__ + "static/media/websamuraj.95589407.webp";